module.exports = __webpack_public_path__ + "static/img/10.cf05ce5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/zh/10.png
// module id = TqUf
// module chunks = 0